<template>
  <div class="flex flex-col h-full w-full">
    <iframe
      src="https://letscrm.omniflex.com.br"
      class="w-full h-full border-0"
      title="CRM"
      allow="fullscreen"
    />
  </div>
</template>

<script>
export default {
  name: 'CrmPage',
};
</script>
